import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"padding":"1em","padding-top":"0"} }
const _hoisted_2 = { style: {"margin-top":"1em"} }

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import IconKey from './iconKey.vue';
import type { IconKeyModel } from '@/models/sidebar/iconKey.model';


export default /*@__PURE__*/_defineComponent({
  __name: 'arrowBlock',
  setup(__props) {

const { t } = useI18n();

const arrows = computed<IconKeyModel[]>(() => [
  { icon: 'fa-arrow-right', name: (t('keys.icons.40_commando')), color: '#2ecc71', customIcon: false },
  { icon: 'fa-arrow-right', name: (t('keys.icons.42_commando')), color: '#e74c3c', customIcon: false },
  { icon: 'fa-arrow-right', name: (t('keys.icons.45_commando')), color: '#3498db', customIcon: false }
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("hr", { class: "info-divider" }, null, -1)),
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_unref(t)('keys.movement')), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(arrows.value, (arrow, index) => {
      return (_openBlock(), _createBlock(IconKey, {
        key: index,
        icon: arrow.icon,
        color: arrow.color,
        name: arrow.name,
        "custom-icon": arrow.customIcon
      }, null, 8, ["icon", "color", "name", "custom-icon"]))
    }), 128))
  ]))
}
}

})